module.exports = __webpack_public_path__ + "img/mobile-41.df1ca0dc.png";